module.exports = __webpack_public_path__ + "img/flag-bgr.ff44e3eb.svg";